import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: '/404'
  },

  /**
   * 2021校园分渠道拉新活动工具
   */
  {
    path: "/inviteRecords",
    name: "InviteRecords",
    component: () => import("../views/activity-2021/InviteRecords"),
    meta: {
      name: "活动邀请页-智联校园",
      pagecode: '5404'
    }
  },
  {
    path: "/nineFieldResume",
    name: "NineFieldResume",
    component: () => import("../views/activity-2021/NineFieldResume"),
    meta: {
      name: "活动信息填写-智联校园",
      pagecode: '5405'
    }
  },
  {
    path: "/nineFieldOverseas",
    name: "NineFieldOverseas",
    component: () => import("../views/activity-overseas/NineFieldOverseas"),
    meta: {
      name: "海外活动",
    }
  },
  {
    path: "/hasJoined",
    name: "HasJoined",
    component: () => import("../views/activity-2021/HasJoined"),
    meta: {
      name: "活动邀请页-智联校园"
    }
  },
  {
    path: "/404",
    name: "404",
    component: () => import("../views/activity-2021/NotFound"),
    meta: {
      name: "404"
    }
  },
  {
    path: "/offline",
    name: "Offline",
    component: () => import("../views/activity-overseas/Offline"),
    meta: {
      name: "活动已下线"
    }
  },

  /**
   * 助力活动
   */
  {
    path: "/joinActivity",
    name: "JoinActivity",
    component: () => import("../views/help-activity/JoinActivity"),
    meta: {
      name: "萌新开学季-燃放新生力量",
    }
  },
  {
    path: "/helpActivityApply",
    name: "HelpActivityApply",
    component: () => import("../views/help-activity/HelpActivityApply"),
    meta: {
      name: "萌新开学季-燃放新生力量",
    }
  },
  {
    path: "/helpActivity",
    name: "HelpActivity",
    component: () => import("../views/help-activity/HelpActivity"),
    meta: {
      name: "萌新开学季-燃放新生力量",
    }
  },
  {
    path: "/helpActivityEntry",
    name: "HelpActivityEntry",
    component: () => import("../views/help-activity/HelpActivityEntry"),
    meta: {
      name: "萌新开学季-燃放新生力量",
    }
  },
  {
    path: "/helpActivityRankList",
    name: "HelpActivityRankList",
    component: () => import("../views/help-activity/HelpActivityRankList"),
    meta: {
      name: "萌新开学季-燃放新生力量",
    }
  },

  /**
   * rd线下投递
   */
   {
    path: "/companyRecommend",
    name: "CompanyRecommend",
    component: () => import("../views/rd/CompanyRecommend"),
    meta: {
      name: "企业推荐",
    }
  },
  {
    path: "/recommendHall",
    name: "RecommendHall",
    component: () => import("../views/rd/RecommendHall"),
    meta: {
      name: "企业推荐大厅",
    }
  },
  {
    path: "/companyRecommendList",
    name: "CompanyRecommendList",
    component: () => import("../views/rd/CompanyRecommendList"),
    meta: {
      name: "企业推荐",
    }
  },
  {
    path: "/jobRecommendList",
    name: "JobRecommendList",
    component: () => import("../views/rd/JobRecommendList"),
    meta: {
      name: "岗位推荐",
    }
  },
  {
    path: "/jobFairRecommendList",
    name: "JobFairRecommendList",
    component: () => import("../views/rd/JobFairRecommendList"),
    meta: {
      name: "双选会推荐",
    }
  },
  {
    path: "/companyHome",
    name: "CompanyHome",
    component: () => import("../views/rd/CompanyHome"),
    meta: {
      name: "公司首页",
    }
  },
  {
    path: "/jobIntroduce",
    name: "JobIntroduce",
    component: () => import("../views/rd/JobIntroduce"),
    meta: {
      name: "职位介绍",
    }
  },
  {
    path: "/sendSuccess",
    name: "SendSuccess",
    component: () => import("../views/rd/SendSuccess"),
    meta: {
      name: "投递成功",
    }
  },
  {
    path: "/jobFairDetail",
    name: "JobFairDetail",
    component: () => import("../views/rd/JobFairDetail"),
    meta: {
      name: "双选会",
    }
  },
];



const router = new VueRouter({
  // mode: "history",
  base: process.env.BASE_URL,
  routes
});
router.beforeEach((to, from, next) => {
  if (to.meta.name) {
    document.title = to.meta.name
  }
  next()
})

export default router;
